

























































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';

import { formatAltitude, formatDistance } from '~/utils/units.js';
import { apiQueryBuilder, objectIsEmpty } from '~/utils/common.js';
import { destinations } from '~/utils/static-datas.js';
import { difficultyHandle, getSportTags, replaceUrl, routeType } from '~/utils/explorer.js';

import ChevronRightSolid from '~/components/icons/ChevronRightSolid.vue';
import ProfileRunSportTag from '~/components/partials/ProfileRunSportTag.vue';
import FlagstartOutline from '~/components/icons/FlagstartOutline.vue';
import ClockOutline from '~/components/icons/ClockOutline.vue';
import FlagendOutline from '~/components/icons/FlagendOutline.vue';
import DistanceOutline from '~/components/icons/DistanceOutline.vue';
import ArrowTrendingUp from '~/components/icons/ArrowTrendingUp.vue';
import ArrowTrendingDown from '~/components/icons/ArrowTrendingDown.vue';
import ActivityOutline from '~/components/icons/ActivityOutline.vue';
import WarningOutline from '~/components/icons/WarningOutline.vue';
import DotsVerticalSolid from '~/components/icons/DotsVerticalSolid.vue';
import PrintOutline from '~/components/icons/PrintOutline.vue';
import HeartOutline from '~/components/icons/HeartOutline.vue';
import RelatedDestinationItem from '~/components/lists/items/RelatedDestinationItem.vue';
import PhotosFeed from '~/components/lists/PhotosFeed.vue';
import ProvidersFeed from '~/components/lists/ProvidersFeed.vue';
import LocalisationRouteCard from '~/components/cards/LocalisationRouteCard.vue';
import RoutesFeed from '~/components/lists/RoutesFeed.vue';
import Breadcrumb from '~/components/partials/Breadcrumb.vue';
import ReviewsFeed from '~/components/lists/ReviewsFeed.vue';
import RouteTimes from '~/components/lists/RouteTimes.vue';
import RouteTimesModal from '~/components/modals/RouteTimesModal.vue';
import Toast from '~/components/partials/Toast.vue';
import RouteStickyMenu from '~/components/menus/RouteStickyMenu.vue';
import LightningSolid from '~/components/icons/LightningSolid.vue';
import DownloadTopSolid from '~/components/icons/DownloadTopSolid.vue';
import ShareSolid from '~/components/icons/ShareSolid.vue';
import FacebookSolid from '~/components/icons/FacebookSolid.vue';
import LoopOutline from '~/components/icons/LoopOutline.vue';
import DownloadBottomSolid from '~/components/icons/DownloadBottomSolid.vue';
import ScrollTrap from '~/components/partials/ScrollTrap.vue';
import ConfirmModal from '~/components/modals/ConfirmModal.vue';
import ReportModal from '~/components/modals/ReportModal.vue';
import PinOutline from '~/components/icons/PinOutline.vue';
import SpotOutline from '~/components/icons/SpotOutline.vue';

import Dropdown from '~/components/partials/Dropdown.vue';
import LabelsInfos from "~/components/partials/LabelsInfos.vue";
import MapOutline from "~/components/icons/MapOutline.vue";
import ArrowNarrowRightSolid from "~/components/icons/ArrowNarrowRightSolid.vue";
import SelectInput from "~/components/inputs/SelectInput.vue";
import { colorMappings, routeExtra } from "~/utils/routes";
import { generateORSJson } from "~/utils/topography-calculator";
import HandiSolid from "~/components/icons/HandiSolid.vue";
import LocalisationRoutesMobileModal from "~/components/lists/items/LocalisationRoutesMobileModal.vue";
import { storeLinks } from '~/utils/app-config';

const Modal: Types.Dictionary<string> = {
  TIMES: 'times',
  REPORT_MODAL: 'report-modal',
  NEED_LOGIN: 'need-login',
  NEED_LOGIN_DOWNLOAD: 'need-login-download',
};

@Component({
  components: {
    LocalisationRoutesMobileModal,
    HandiSolid,
    ArrowNarrowRightSolid,
    MapOutline,
    SelectInput,
    LabelsInfos,
    Dropdown,
    ChevronRightSolid,
    ProfileRunSportTag,
    FlagstartOutline,
    FlagendOutline,
    WarningOutline,
    DotsVerticalSolid,
    PrintOutline,
    HeartOutline,
    RelatedDestinationItem,
    PhotosFeed,
    ProvidersFeed,
    LocalisationRouteCard,
    RoutesFeed,
    Breadcrumb,
    ReviewsFeed,
    RouteMap: () => {
      if (process.client) {
        return import('~/components/maps/RouteMap.vue');
      }
    },
    RouteTimes,
    RouteTimesModal,
    Toast,
    RouteStickyMenu,
    LightningSolid,
    DownloadTopSolid,
    DownloadBottomSolid,
    ShareSolid,
    FacebookSolid,
    LoopOutline,
    ClockOutline,
    ScrollTrap,
    ConfirmModal,
    ReportModal,
    PinOutline,
    SpotOutline,
  },
  computed: {
    ...mapState([
      'iframeMode',
      'iframeRouteHeader',
      'iframeRoutePub',
      'iframeRouteDescription',
      'iframeRouteBackSearch',
    ]),
    ...mapState('lang', {
      locale: 'locale',
    }),
    ...mapState('explorer', [
      'route',
      'destination',
      'destinationProviders',
      'destinationProvidersSuggestions',
      'routesSuggestions',
      'toggleRouteMap',
    ]),
    iframeAndHeader (this: { iframeMode: boolean; iframeRouteHeader: boolean }): boolean {
      return this.iframeRouteHeader && this.iframeMode;
    },
  },
  middleware: ['noauth'],
  head () {
    const self: any = this;
    const description = self.route?.description?.trim().replace(/<\/?[^>]+(>|$)/g, "");
    const locale: string = self.$store.state.lang.locale;
    return {
      title: `${self.route.title} - On Piste`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: description,
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: `${self.route.title} - On Piste`,
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description,
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: self.route.media?.length ? self.$thumbnailUrl(self.route.media[0], 1200) : 'https://www.onpiste.com/img/placeholders/route-placeholder.png',
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: `https://www.onpiste.com/${locale === 'fr' ? '' : `${locale}/`}explorer/routes/${self.$slugify(self.route.title)}-${self.route.id}`,
        },
      ],
    };
  },
  async fetch () {
    const self: any = this;
    await self.populateDestinationDatas();
  },
  async asyncData ({
    route,
    store,
    error,
    app,
  }) {
    const errorInstance: any = error;

    if (
      route.params.routeid.split('-').pop() === '' ||
      isNaN(Number(route.params.routeid.split('-').pop()?.trim()))
    ) {
      return errorInstance({
        statusCode: 404,
        response: { data: { detail: 'Unknown route' } },
      });
    }

    try {
      if (route.query?.preview) {
        await store.dispatch('explorer/getRoutePreview', {
          id: route.params.routeid.split('-').pop()?.trim(),
          token: route.query.preview,
          lang: store.state.lang.locale,
        });
      } else {
        await store.dispatch('explorer/getRoute', {
          id: route.params.routeid.split('-').pop()?.trim(),
          lang: store.state.lang.locale,
        });
      }
    } catch (e) {
      return errorInstance({
        statusCode: e.response.status,
        response: { data: { detail: app.i18n.t(e.response.data.detail) } },
      });
    }
  },
})
export default class DestinationRouteId extends Vue {
  locale: string;
  route: Types.Route;
  destination: Types.DestinationItem;
  destinationProviders: Types.Provider[] | Types.ProviderList;
  destinationProvidersSuggestions: Types.Provider[];
  routesSuggestions: Types.Route[];
  iframeMode: null;
  iframeRouteHeader: null;
  iframeRoutePub: null;
  iframeRouteDescription: null;
  iframeRouteBackSearch: null;

  displayToast: boolean = false;
  textOfToast: string = '';
  isMapFullscreen: boolean = false;
  topography: any = {};
  dropdownOptions: Array<{ modalId: string, name: string }> = [
    {
      modalId: Modal.REPORT_MODAL,
      name: this.$t('routeStickyMenu.reportModalTitle'),
    },
  ];

  Modal = Modal;
  modal: string = '';

  shouldDisplayMenu: boolean = false;
  destinations: any = destinations;
  storeLinks = storeLinks;

  heightGraphFilterOptions: object[] = [
    { id: routeExtra.steepness, name: this.$t('explorer.routes.heightGraph.filter.options.slopePercentage') },
    { id: routeExtra.routefoot, name: this.$t('explorer.routes.heightGraph.filter.options.footPlacement') },
    { id: routeExtra.routesize, name: this.$t('explorer.routes.heightGraph.filter.options.roadWidth') },
  ]

  heightGraphFilterValue: any = this.heightGraphFilterOptions[0];

  get legends () {
    if (this.heightGraphFilterValue) return colorMappings[this.heightGraphFilterValue.id];
  }

  get sortedLegends () {
    const legendEntries = Object.entries(this.legends || {});
    return legendEntries
      // Remove UNDEFINED legend if it has 0%
      .filter(([key, legend]) => {
        const isUndefined = legend.text === 'UNDEFINED';
        const percent = this.getPercent(key);
        return !(isUndefined && percent === 0);
      })
      .sort((a, b) => {
        return (a[1].order ?? 99) - (b[1].order ?? 99);
      });
  }

  get destinationCountryCode () {
    if (this.destinationIsEmpty) return 'FR';
    return this.destination?.locations[0].countrycode;
  }

  get availableHeightGraphsOptions () {
    return this.heightGraphFilterOptions.filter(
      (option: any) => {
        if (typeof this.topography?.features === 'undefined') return false;
        return this.topography?.features[0]?.properties?.extras[option.id] !== undefined;
      },
    );
  }

  /* Returns reactive list of print dropdown options */
  get printOptions () {
    return [
      {
        path: `${this.$slugify(this.route.title)}-${this.route.id}/print`,
        name: this.$t('routeStickyMenu.print'),
      },
      {
        path: '#',
        name: this.$t('routeStickyMenu.gpx'),
      },
    ];
  }

  get media () {
    if (this.route.ffc_id !== null) {
      return [...this.route.media, '/img/sites-ffc.jpg'];
    }

    if (this.route.ffv_id !== null) {
      return [...this.route.media, '/img/sites-ffv.jpg'];
    }

    return this.route.media;
  }

  /*
    Returns the providers to display on RouteMap if match filters applied
    in map
  */
  get providersToShow () {
    // this.destinationProviders can be in two object formats,
    // this condition will avoid page crash if object structure is
    // not correct (this structure is used on destinationId/offer page)
    if (this.destinationProviders?.items || !this.destinationProviders.length) return [];

    return this.destinationProviders?.filter((v: Types.Provider, i: number, a: any) => {
      return a?.findIndex((t: Types.Provider) => (t.id === v.id)) === i;
    }) || [];
  }

  /* Returns translated route type with util */
  get routeType () {
    return routeType(this.route?.type);
  }

  /*
    Returns route's points of interest except directions type (redundant)
  */
  get routePois () {
    return this.route.pois?.filter((poi: Types.RoutePoi) => ![
      1, // Types.PoiType.DIRECTION
      12, // Types.PoiType.FEET_POSE
      13, // Types.PoiType.PATH_WIDTH
    ].includes(poi.type));
  }

  /* Computed to handle the style of route state to display in template */
  get handleRouteStatus () {
    if (this.route.route_state === 'CLOSED') return 'bg-danger-50 text-danger-default';
    if (this.route.route_state === 'WARNING') return 'bg-warning-50 text-warning-default';
    return 'bg-success-50 text-success-default';
  }

  /* Computed skeleton handle */
  get destinationIsEmpty () {
    return objectIsEmpty(this.destination);
  }

  /* Check if user is connected based on cookie value */
  get checkUserConnection () {
    return this.$cookies.get('token');
  }

  /* Returns reactive breadcrumb links with some store values */
  get breadcrumbMenu () {
    return [
      {
        path: '/',
        name: this.$t('explorer.routes.breadcrumb.home'),
      },
      this.route?.destination_id === null
        ? {
            path: '/explorer?tab=routes',
            name: this.$t('explorer.routes.breadcrumb.routes'),
          }
        : {
            path: '/explorer',
            name: this.$t('explorer.routes.breadcrumb.explorer'),
          },
      this.route?.destination_id === null
        ? null
        : {
            path: `/explorer/destinations/${this.$slugify(`${this.destination.title}-${this.destination.id}`)}`,
            name: this.destination.title,
          },
      this.route?.destination_id === null
        ? null
        : {
            path: `/explorer/destinations/${this.$slugify(`${this.destination.title}-${this.destination.id}`)}/offer?tab=routes`,
            name: this.$t('explorer.routes.breadcrumb.routes'),
          },
      {
        path: '',
        name: this.route?.title,
        isActive: true,
      },
    ].filter(crumb => crumb !== null);
  }

  /* Returns reactive submenu links with some store values */
  get subMenuLinks () {
    return [
      {
        link: '#route',
        name: this.route.type === 'ROUTE' ? this.$t('explorer.routes.submenu.routes') : this.$t('explorer.routes.submenu.spots'),
        isDisplayed: true,
      },
      {
        link: '#description',
        name: this.$t('explorer.routes.submenu.description'),
        isDisplayed: true,
      },
      {
        link: '#photos',
        name: this.$t('explorer.routes.submenu.photos'),
        isDisplayed: this.media?.length > 0,
      },
      // { link: '#reviews', name: this.$t('explorer.routes.submenu.reviews'), isDisplayed: true },
      {
        link: '#providers',
        name: this.$t('explorer.routes.submenu.providers'),
        isDisplayed: this.destinationProvidersSuggestions.length > 0,
      },
      {
        link: '#similar-routes',
        name: this.$t('explorer.routes.submenu.similar'),
        isDisplayed: this.routesSuggestions.length > 0,
      },
    ];
  };

  /*
    Returns the parsed GeoJson of the route track if available. This Json will
    be passed as prop to be used in RouteMap
  */
  get routeGeoJson () {
    return this.route?.track ? JSON.parse(this.route?.track || '') : null;
  }

  get staticRatings () {
    if (this.destinationIsEmpty) return null;

    return this.destinations[0].sports[0].routes[0].ratings;
  }

  getPercent (key: string) {
    if (!this.filteredTopography.features) {
      return '';
    }
    const extras = this.filteredTopography.features[0].properties.extras;
    const extra = extras[this.heightGraphFilterValue.id];
    return Math.round(extra.summary.find((summary: { value: number; amount: number }) => summary.value === parseInt(key))?.amount ?? 0);
  }

  getLegend (type: string, key:string) {
    return this.$t('explorer.routes.segments.' + type + '.' + key.toLowerCase());
  }

  /*
    Returns the link to all providers related to destination, using slugify
    to construct valid URL.
  */
  get linkToProviders () {
    if (this.destinationIsEmpty) return '';

    return `/explorer/destinations/${this.$slugify(`${this.destination.title}-${this.destination.id}`)}/offer?tab=providers`;
  }

  get backToSearch () {
    const savedQueryParams = this.$store.state.iframeRouteBackSearch ?? {};
    const filterParams = apiQueryBuilder(savedQueryParams);
    return `/explorer/destinations/${this.$slugify(`${this.destination.title}-${this.destination.id}`)}/offer${filterParams}`;
  }

  get routeDetail () {
    return `/explorer/routes/${this.route?.id}`;
  }

  /* Computed skeleton handle */
  get routeIsEmpty () {
    return objectIsEmpty(this.route);
  }

  /* Computed method to return complete URL of page for ShareNetwork button */
  get urlPage () {
    if (process.client) return window.location.href;
    return '';
  }

  /* Returns translated route sport tags with util */
  get routeSportTag () {
    return getSportTags(this.route?.sport);
  }

  /* Returns route's distance in user preferred unit */
  get routeDistance () {
    return this.route?.distance ? formatDistance(this.route?.distance) : '-';
  }

  /* Returns route's positive elevation in user preferred unit */
  get elevationPlus () {
    return this.route?.elevation_pos ? formatAltitude(this.route?.elevation_pos) : '-';
  }

  /* Returns route's negative elevation in user preferred unit */
  get elevationMinus () {
    return this.route?.elevation_neg ? formatAltitude(this.route?.elevation_neg) : '-';
  }

  /* Returns route's max altitude in user preferred unit */
  get altMax () {
    return this.route?.highest_point ? formatAltitude(this.route?.highest_point) : '-';
  }

  /* Returns list of previous KPIs and associated translated texts and icons (Vue) */
  get kpis () {
    const array: { id: string, icon: any, title: string, stat: any, customClass?: string }[] = [
      {
        id: 'distance',
        icon: DistanceOutline,
        title: this.$t('localisationRouteCard.distance'),
        stat: this.routeDistance,
      },
      {
        id: 'elevationPlus',
        icon: ArrowTrendingUp,
        title: this.$t('localisationRouteCard.elevationPlus'),
        stat: this.elevationPlus,
      },
      {
        id: 'elevationMinus',
        icon: ArrowTrendingDown,
        title: this.$t('localisationRouteCard.elevationMinus'),
        stat: this.elevationMinus,
      },
      {
        id: 'altitude-max',
        icon: DownloadTopSolid,
        title: this.$t('localisationRouteCard.maxAltitude'),
        stat: this.altMax,
      },
      {
        id: 'difficulty',
        icon: ActivityOutline,
        title: this.$t('localisationRoutesMobileModal.difficulty'),
        stat: this.route.difficulty ? this.$t(this.difficulty(this.route.difficulty).label) : '-',
        customClass: this.route.difficulty ? this.difficulty(this.route.difficulty).labelStyle : '',
      },
    ];

    if (this.route.difficulty_ebike) {
      array.push({
        id: 'electricalDifficulty',
        icon: LightningSolid,
        title: this.$t('localisationRoutesMobileModal.electricalDifficulty'),
        stat: this.route.difficulty_ebike ? this.$t(this.difficulty(this.route.difficulty_ebike).label) : '',
        customClass: this.route.difficulty_ebike ? this.difficulty(this.route.difficulty_ebike).labelStyle : '',
      });
    }

    // The logic below will format durations based on their length:
    // superior to 24 hours, less than one hour, between these two
    if (this.route?.duration_min && this.route?.duration_max) {
      let minDuration: string = '';
      if (this.$dayjs.duration(this.route?.duration_min, 'minutes').asHours() < 1) {
        minDuration = `${this.$dayjs.duration(this.route?.duration_min, 'minutes').asMinutes()}min`;
      } else if (this.$dayjs.duration(this.route?.duration_min, 'minutes').asHours() > 24) {
        minDuration = `${Math.ceil(this.$dayjs.duration(this.route?.duration_min, 'minutes').asHours())}h`;
      } else {
        minDuration = `${this.$dayjs.duration(this.route?.duration_min, 'minutes').format('H:mm')}h`;
      }

      let maxDuration: string = '';
      if (this.$dayjs.duration(this.route?.duration_max, 'minutes').asHours() < 1) {
        maxDuration = `${this.$dayjs.duration(this.route?.duration_max, 'minutes').asMinutes()}min`;
      } else if (this.$dayjs.duration(this.route?.duration_max, 'minutes').asHours() > 24) {
        maxDuration = `${Math.ceil(this.$dayjs.duration(this.route?.duration_max, 'minutes').asHours())}h`;
      } else {
        maxDuration = `${this.$dayjs.duration(this.route?.duration_max, 'minutes').format('H:mm')}h`;
      }

      // Put this KPI at first position in array
      array.splice(1, 0, {
        id: 'duration',
        icon: ClockOutline,
        title: this.$t('profileRunCard.durationTitle'),
        stat: `${minDuration}-${maxDuration}`,
      });
    }
    return this.iframeMode ? array.filter(({ id }) => !['elevationMinus', 'altitude-max', 'duration'].includes(id)) : array;
  }

  get averageRatesNote () {
    if (this.staticRatings) {
      let sum: number = 0;
      for (var i = 0; i < this.staticRatings.length; i++) {
        sum += this.staticRatings[i].note;
      }
      return sum / this.staticRatings.length;
    }
    return null;
  }

  /*
    When report route form is submitted, we display a toast and remove it
    after 5 seconds
  */
  @Watch('displayToast')
  setToastTimeout () {
    setTimeout(() => {
      this.displayToast = false;
      this.textOfToast = '';
    }, 5000);
  }

  mounted () {
    if (process.client) {
      // We will display sticky menu when user has scrolled a certain amount
      window.addEventListener('scroll', this.displayStickyMenu);

      this.callTopographyMethod(this.routeGeoJson);

      window.dataLayer.push({
        'Destination': this.destination?.title,
        'DestinationID': this.destination?.id,
        'Sport': this.route.sport.title,
        'SportID': this.route.sport.id,
        'Univers': this.route.sport.universe,
        'Difficulté': this.$i18n.t(difficultyHandle(this.route.difficulty).label),
        'DifficultéID': this.route.difficulty,
      });
    }

    /*
      Using util method to adapt URL to a specific format containing title and
      ID of retrieved element for better SEO.
    */
    replaceUrl(
      this.$route.params.routeid,
      `${this.locale !== 'fr' ? `/${this.locale}` : ''}/explorer/routes/${this.$slugify(this.route.title)}`,
      this.$slugify(this.route?.title),
    );
  }

  beforeDestroy () {
    // Prevents some unexpected behavior where topography doesn't update
    // between two route pages
    this.topography = [];

    this.$store.commit('explorer/SET_DESTINATION_PROVIDERS', []);

    // Removes scroll event listener
    if (process.client) window.removeEventListener('scroll', this.displayStickyMenu);
  }

  /*
    In SSR mode, this method is called in fetch so the data will be ready to be
    passed as a prop in RouteMap, and create the heightgraph correctly inside
    of it
  */
  callTopographyMethod (val: any) {
    this.topography = generateORSJson({ ...val.features[0].geometry }, {
      segment_route_foot: this.route.segment_route_foot,
      route_foot: this.route.route_foot,
      segment_route_size: this.route.segment_route_size,
      route_size: this.route.route_size,
    });
  }

  // based on heightGraphFilterValue, return only corresponding data : steepness or extra
  get filteredTopography () {
    if (!this.topography?.features) {
      return this.topography;
    }

    if (this.heightGraphFilterValue) {
      return {
        ...this.topography,
        features: this.topography.features.map((feature: any) => ({
          ...feature,
          properties: {
            ...feature.properties,
            extras: feature.properties.extras?.[this.heightGraphFilterValue.id]
              ? { [this.heightGraphFilterValue.id]: feature.properties.extras[this.heightGraphFilterValue.id] }
              : {},
          },
        })),
      };
    }

    return this.topography;
  }

  /* Prepares the datas to send to the API when reporting a route */
  emitReport (val: { category: string, text: string, media: string[], route_id?: number }) {
    const object = val;
    object.route_id = this.route.id;
    this.reportRoute(object);
  }

  /* Uses API POST to send report, then displays a toast */
  async reportRoute (payload: any) {
    await this.$store.dispatch('activities/reportRoute', {
      content: payload,
      lang: this.locale,
    });
    this.$root.$emit('close-report-modal');
    this.displayToast = true;
    this.textOfToast = this.$t('explorer.routes.confirmReport');
    this.modal = '';
  }

  /*
    If user is connected and asks to download the route, we will create a GPX
    file and directly download it on user's device.
  */
  async createAndDownloadGpx (path: string, name: string) {
    window.dataLayer.push({
      'Telechargement': name,
    });

    if (path === '#') {
      const gpx = await this.$store.dispatch('explorer/downloadRouteGpx', Number(this.$route.params.routeid.split('-').pop()?.trim()));
      const blob = new Blob([gpx], { type: 'Application/octet-stream' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `${this.route.title}.gpx`;
      link.click();
      URL.revokeObjectURL(link.href);
    } else {
      window.open(path);
    }
  }

  /* Returns route color to be used in map based on route's difficulty */
  routeColor () {
    switch (this.route.difficulty) {
      case 0:
        return '#9FA4AE';
      case 1:
        return '#3FA535';
      case 2:
        return '#009FE3';
      case 3:
        return '#CD171A';
      case 4:
        return '#000';
      default:
        return '#9FA4AE';
    }
  }

  /* Uses util to get right styles to apply in template for route's difficulty */
  difficulty (val: number) {
    return difficultyHandle(val);
  }

  /* Will display sticky menu when user has reached "routeTitle" div */
  displayStickyMenu () {
    if (process.client) {
      const stickyDiv: any = document.getElementById('routeTitle');
      const coords: any = stickyDiv.getBoundingClientRect();

      this.shouldDisplayMenu = coords.bottom <= 0;
    }
  }

  /*
    In this page, sports tags are clickable and redirect to explorer.
    We will construct the link of the button using sport id to filter elements
    when moving to explorer page.
  */
  redirectToExplorer (tag: Types.SportItem) {
    const route: any = this.localePath(`/explorer?sport=${tag.id}`);
    this.$router.push(route);
  }

  /*
    Redirects to signIn page so the user can signIn to use dropdown actions.
    When signed, user will be redirected to the route page (?next query).
  */
  goToSignin () {
    const route: any = this.localePath(`/signin?next=${this.$route.path}`);
    this.$router.push(route);
  }

  /*
    In SSR mode this method is called in fetch, before the page mounts.
    The tmeplate wil be rendered with datas of element.
  */
  async populateDestinationDatas () {
    if (this.route?.destination_id !== null) {
      await this.$store.dispatch('explorer/getDestination', {
        id: this.route?.destination_id,
        lang: this.locale,
      });

      await this.$store.dispatch('explorer/getDestinationProvidersSuggestions', {
        destination_id: this.route?.destination_id,
        lang: this.locale,
      });

      await this.$store.dispatch('explorer/getDestinationProvidersAllListed', {
        destination_id: this.route?.destination_id,
        lang: this.locale,
      });
    }

    await this.$store.dispatch('explorer/getSimilarRoutes', {
      id: this.route?.id,
      lang: this.locale,
    });
  }
};
